module.exports = __webpack_public_path__ + "static/media/rotation-from-horizontal-to-vertical.654c0308.gif";